import { extra } from '@/theme/colors/palettes';
import { VStack } from '@chakra-ui/react';
import React, { PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  noShadow?: boolean;
  paddingBottom?: string;
}

const OverviewSectionContainer = ({ children, noShadow, paddingBottom = '16px' }: Props) => {
  return (
    <VStack
      style={{
        width: '100%',
        background: extra.white,
        padding: `16px 20px ${paddingBottom} 20px`,
        boxShadow: noShadow ? 'none' : '0px 8px 40px 0px #0041790D',
        borderRadius: 12,
      }}
    >
      {children}
    </VStack>
  );
};

export default OverviewSectionContainer;
